meedy.filter('meedyConsole',
    function() {
        return function(input, passThrough) {
            if (_.isUndefined(passThrough) || !passThrough) {
                return null;
            }
            else {
                return input;
            }
        };
    }
);